import { QUERY_KEYS } from 'api/query-keys';
import { sharedShiftService } from 'api/services';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { useSiteDetection } from 'shared/hooks';
import { BulkShiftActionData } from 'api';

type OpenShiftToPartnersMutationParams = {
  shiftIds: string[];
  partnerIds: string[];
};

type ShiftPartnerMutationOptions = UseMutationOptions<
  BulkShiftActionData,
  unknown,
  OpenShiftToPartnersMutationParams
>;

export const useBulkOpenShiftsToPartners = () => {
  const { site } = useSiteDetection();
  const mutationFn = async (params: OpenShiftToPartnersMutationParams) =>
    await sharedShiftService.bulkAssignPartnersToShifts(site, params.shiftIds, params.partnerIds);
  const queryClient = useQueryClient();
  const mutationOptions: ShiftPartnerMutationOptions = {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.shifts());
      queryClient.invalidateQueries(QUERY_KEYS.partners());
    },
  };

  return useMutation(mutationFn, mutationOptions);
};
